<template>
    <div id="apptradingGroupReports">
        <div class="c-subheader">
            <h5 id="headertradingGroup"></h5>
        </div>
        <ejs-tab id="element" :selectedItem="selectedItem" ref=tradingGroupReportTabs>
            <e-tabitems>
                <e-tabitem :header='headerText0' :content='PositionReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText1' :content='M2MReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText9' :content='VolumeReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText3' :content='CostAndPricingReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='tradingGroupAlertsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :content='HedgingOverviewReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText6' :content='TicketsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText8' :content='TicketsLogsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText7' :content='hypotheticalTradesTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
        <!--<ejs-toast ref='toastrRef' id='tradingGroupToast' :position='position'></ejs-toast>-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import PositionReport from '@/views/templates/ATGReports/PositionReportTemplate.vue';
    import M2MReportTemplate from '@/views/templates/ATGReports/M2MReportTemplate.vue';
    import CostAndPricingReportTemplate from '@/views/templates/ATGReports/CostAndPricingReportTemplate.vue';
    import tradingGroupAlertsReportTemplate from '@/views/templates/ATGReports/TradingGroupAlertsReportTemplate.vue';
    import TicketsReportTemplate from '@/views/templates/ATGReports/TicketsReportTemplate.vue';
    import HedgingOverviewReportTemplate from '@/views/templates/ATGReports/HedgingOverviewReportTemplate.vue';
    import HypotheticalTrades from '@/views/templates/ATGReports/HypotheticalTradeReportTemplate.vue';
    import TicketsLogsReportTemplate from '@/views/templates/ATGReports/TicketsLogsReportTemplate.vue';
    import VolumeReportTemplate from '@/views/templates/ATGReports/VolumeReportTemplate.vue';
    import urls from '../../../common/urls';
    import apis from '../../../common/network';

    Vue.use(TabPlugin);
    export default {
        name: 'tradingGroupReportTabs',
        created() {
            this.$store.commit('setReportsTradingGroupId', this.$route.params.tradingGroupId);
            this.fetchData(this.$route.params.tradingGroupId);
            this.fetchtradingGroup(this.$route.params.tradingGroupId);

        },
        data: function () {
            return {
                headerText0: { text: 'Position Summary' },
                headerText1: { text: 'M2M' },
                headerText3: { text: 'ATG Performance' },
                headerText5: { text: 'Hedging Overview' },
                headerText6: { text: 'Trades' },
                headerText7: { text: 'Hypothetical Trades' },
                headerText8: { text: 'Trades Logs' },
                headerText9: { text: 'Volume Report' },
                position: { X: 'Right', Y: 'Bottom' },
                propsData: null,
                selectedItem: this.$route.params.callerTab == "hypothetical" ? 8 : this.$route.params.callerTab == "Trades" ? 6 : 0,
                deadline: 0,
                status: 0,
                hit: 0,
                AlertsCount:0,
                PositionReportTemplate: function () {
                    return {
                        template: {
                            extends: PositionReport
                        }
                    };
                },
                M2MReportTemplate: function () {
                    return {
                        template: {
                            extends: M2MReportTemplate
                        }
                    }
                },
                VolumeReportTemplate: function () {
                    return {
                        template: {
                            extends: VolumeReportTemplate
                        }
                    }
                },
                CostAndPricingReportTemplate: function () {
                    return {
                        template: {
                            extends: CostAndPricingReportTemplate
                        }
                    }
                },
                tradingGroupAlertsReportTemplate: function () {
                    return {
                        template: {
                            extends: tradingGroupAlertsReportTemplate
                        }
                    }
                },
                HedgingOverviewReportTemplate: function () {
                    return {
                        template: {
                            extends: HedgingOverviewReportTemplate
                        }
                    }
                },
                TicketsReportTemplate: function () {
                    return {
                        template: {
                            extends: TicketsReportTemplate
                        }
                    }
                },
                TicketsLogsReportTemplate: function () {
                    return {
                        template: {
                            extends: TicketsLogsReportTemplate
                        }
                    }
                },
                hypotheticalTradesTemplate: function () {
                    return {
                        template: {
                            extends: HypotheticalTrades
                        }
                    }
                }
            }
        },
        methods: {
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCountsATG?tradingGroupId=${id}`).then(it => {
                    this.deadline = it.data.deadline;
                    this.status = it.data.status;
                    this.hit = it.data.hit;
                    this.AlertsCount = this.hit + this.deadline + this.status;
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },

            fetchtradingGroup(id) {
                apis.protectedApi.get(`tradingGroup/getTradingGroupName?tradingGroupId=${id}`)
                    .then(response => {

                        this.tradingGroupName = response.data.tradingGroupName;
                        document.getElementById('headertradingGroup').textContent = this.tradingGroupName;

                    }).catch(response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                 );
            }
        },
        computed: {
            headerText4() {
                return { text: "Alerts (" + this.AlertsCount +")"};
            },
        },
    }
</script>

<style scoped>
</style>


<style>
    #headertradingGroup {
        color: #8a93a2;
        margin-top: 10px;
        margin-left: 11px;
    }
</style>